import { useTranslation } from 'react-i18next';
import { SUPPORT_EMAIL, SUPPORT_MAILTO, SUPPORT_WHATSAPP_URL } from '@/lib/contact';
import { trackEvent } from '@/lib/analytics';
import { cn } from '@/lib/utils';

// A HUMAN LINE (Studio Blueprint 05-F): a person answers questions before
// someone buys. The address is the one in lib/contact.ts; the owner picks the
// friendlier mailbox the blueprint proposes, and it changes there only. A
// WhatsApp link joins it only when VITE_SUPPORT_WHATSAPP is set.
export function SupportLine({ where, className }: { where: string; className?: string }) {
  const { t } = useTranslation();
  return (
    <p data-testid="support-line" className={cn('text-center text-[14px] text-muted-foreground', className)}>
      <span className="font-semibold text-foreground">{t('trust.support.lead')}</span>{' '}
      <a
        href={SUPPORT_MAILTO}
        onClick={() => trackEvent('support_contact_clicked', { source: where })}
        className="whitespace-nowrap text-primary underline-offset-4 hover:underline"
        translate="no"
      >
        {SUPPORT_EMAIL}
      </a>
      {SUPPORT_WHATSAPP_URL && (
        <>
          {' · '}
          <a
            href={SUPPORT_WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('support_contact_clicked', { source: where, channel: 'whatsapp' })}
            className="whitespace-nowrap text-primary underline-offset-4 hover:underline"
            translate="no"
          >
            {t('trust.support.whatsapp')}
          </a>
        </>
      )}
      <span> · {t('trust.support.reply')}</span>
    </p>
  );
}
